var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Fragment",
    [
      _c("spinner", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade", duration: { leave: 0, enter: 800 } } },
        [
          _c(
            "carousel",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.loading,
                  expression: "!loading"
                },
                {
                  name: "images-loaded",
                  rawName: "v-images-loaded",
                  value: _vm.imageLoaded,
                  expression: "imageLoaded"
                }
              ],
              key: "carousel",
              ref: "carousel",
              staticClass: "slideshow",
              attrs: {
                perPage: 1,
                mouseDrag: false,
                paginationColor: "#F2C0DE",
                paginationActiveColor: "#F2C0DE",
                paginationPadding: 0,
                paginationSize: 5,
                centerMode: true,
                navigateTo: _vm.navigateTo
              },
              on: { "page-change": _vm.handlePageChange }
            },
            _vm._l(_vm.images, function(image, index) {
              return _c(
                "slide",
                {
                  key: image.key,
                  staticStyle: { visibility: "visible" },
                  on: {
                    "slide-click": function($event) {
                      return _vm.handleImgClick(image, index)
                    }
                  }
                },
                [
                  _c("img", {
                    staticClass: "slide-image",
                    attrs: { src: image.uri, alt: image.alt }
                  })
                ]
              )
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b91c4682", { render: render, staticRenderFns: staticRenderFns })
  }
}